<template>
    <div class="col-lg-12">
        <table-search-and-pagination
            :per-page="perPage"
            :current-page="currentPage"
            :table-data="receiptLogUnits"
            :query="routeQuery"
            :hide-per-page="true"
            @dataUpdated="queriedData = $event"
            @queryUpdated="$emit('search', $event)"
        >
            <div slot="header" class="mb-3">
                <div class="flex-end">
                    <base-button
                        :disabled="deliveryUnits.length === 0"
                        type="primary"
                        @click="requestDelivery"
                    >
                        Request Delivery
                        <span v-if="deliveryUnits.length > 0" class="ml-1">
                            ({{ deliveryUnits.length }})</span
                        >
                    </base-button>
                </div>
                <div
                    v-if="receiptLog.materialType.description === 'Cabinets'"
                    class="col-12"
                >
                    <h4 class="mb-1">
                        <b>Storage Start: </b
                        >{{
                            formatDate(
                                storageStart(receiptLog, receiptLogUnits[0]),
                            )
                        }}
                    </h4>
                </div>
                <div class="col-12 d-flex flex-between">
                    <div>
                        <h4 class="mb-1">
                            <b>Fees Accrued:</b>
                            {{ feesAccruedFormatted(receiptLog) }}
                        </h4>
                        <h4
                            v-if="
                                receiptLog.materialType.description ===
                                'Cabinets'
                            "
                        >
                            <b>Daily Cabinet Rate:</b>
                            {{ dailyCabinetRateFormatted(receiptLog) }}
                        </h4>
                        <h4
                            v-else-if="
                                receiptLog.materialType.description ===
                                'Furniture'
                            "
                        >
                            <b>Daily Furniture Rate:</b>
                            {{ dailyFurnitureRateFormatted() }}
                        </h4>
                    </div>
                    <div>
                        <h4>Show <b>In Stock</b> units only</h4>
                        <base-switch
                            id="showInStockOnly"
                            v-model="inStockOnly"
                            type="primary"
                            on-text="Yes"
                            off-text="No"
                        />
                    </div>
                </div>
            </div>
            <receipt-log-unit-table
                :receipt-log="receiptLog"
                :receipt-log-units="queriedData"
                :clear-selection="clearSelection"
                :material-type="receiptLog.materialType.description"
                :storage-start="storageStart"
                :furniture-fees="furnitureFees"
                :format-number-to-currency="formatNumberToCurrency"
                @selectionChange="deliveryUnits = $event"
            />
        </table-search-and-pagination>
    </div>
</template>
<script>
import moment from "moment-timezone";
import TableSearchAndPagination from "src/components/TableSearchAndPagination";
import { BaseSwitch } from "src/components/UI";
import storageFees from "src/mixins/storageFees";
import ReceiptLogUnitTable from "./ReceiptLogUnitTable.vue";

export default {
    name: "ReceiptLogDetail",
    components: {
        TableSearchAndPagination,
        ReceiptLogUnitTable,
        BaseSwitch,
    },
    mixins: [storageFees],
    props: {
        receiptLogUnits: {
            type: Array,
            required: true,
        },
        receiptLog: {
            type: Object,
            required: true,
        },
        currentPage: {
            type: Number,
            required: true,
        },
        perPage: {
            type: Number,
            default: Number.MAX_VALUE,
        },
        routeQuery: {
            type: String,
            default: "",
        },
        showInStockOnly: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            queriedData: [],
            clearSelection: false,
            showRequestDeliveryModal: false,
            deliveryUnits: [],
        };
    },
    computed: {
        inStockOnly: {
            get() {
                return this.showInStockOnly;
            },
            set(toggle) {
                this.$emit("toggleInStockOnly", toggle);
            },
        },
    },
    watch: {
        deliveryUnits(units) {
            this.clearSelection = !units.length;
        },
    },
    methods: {
        formatDate(date) {
            if (date) {
                const format = "MM/DD/YYYY";
                if (date instanceof moment) {
                    return date.format(format);
                }
                return moment(date).format(format);
            }
            return "--";
        },
        requestDelivery() {
            this.$emit("requestDelivery", this.deliveryUnits);
            this.deliveryUnits = [];
        },
    },
};
</script>
